import React, { useRef } from 'react'
import { Position, Tree } from '@blueprintjs/core'
import { Popover } from '@ui'
import ClearableSelectWrapper from '@ui/selects/ClearableSelectWrapper'
import { Button } from '@ui'
import cx from 'classnames'
import isEmpty from 'lodash/isEmpty'
import { LocationWorkingHoursGroupI } from '@api'
import { UseTreeContentsT } from '../../hooks/useTreeContents'
import { SearchField } from './components'
import css from './locationGroupTrees.module.scss'
import { Popover2 } from '@blueprintjs/popover2'

interface MapFloorSelectionProps {
  locationWorkingHoursGroup: LocationWorkingHoursGroupI
  treeContentsHook: UseTreeContentsT
}

export default function LocationGroupTrees({
  locationWorkingHoursGroup,
  treeContentsHook,
}: MapFloorSelectionProps) {
  const {
    searchQuery,
    treeLocationContents,
    treeSelectedLocationContents,
    handleSearch,
    handleClearSearch,
    handleLocationNodeClick,
    handleLocationNodeCollapse,
    handleLocationNodeExpand,
    handleSelectedLocationNodeClick,
    handleSelectedLocationNodeCollapse,
    handleSelectedLocationNodeExpand,
  } = treeContentsHook
  const popoverRef = useRef<Popover2>(null)

  const onPopoverOpening = (e: HTMLElement) => {
    const indentationFromTop = 100
    const buttonOffsetHeight = popoverRef.current?.targetElement?.offsetHeight || 0
    const buttonOffsetTop = popoverRef.current?.targetElement?.offsetTop || 0
    const topEmptySpace = buttonOffsetHeight + indentationFromTop

    window.scrollTo({
      top: buttonOffsetTop + e.offsetHeight - topEmptySpace,
    })
  }

  return (
    <>
      <div className={cx('mb-4', css.title)}>Location group</div>
      <div
        className={cx(css.list, css.list_selected_location, {
          [css.list_selected_location_editing]: locationWorkingHoursGroup.isBeingEdited,
        })}
      >
        <Tree
          contents={treeSelectedLocationContents}
          onNodeClick={handleSelectedLocationNodeClick}
          onNodeCollapse={handleSelectedLocationNodeCollapse}
          onNodeExpand={handleSelectedLocationNodeExpand}
        />
      </div>
      {locationWorkingHoursGroup.isBeingEdited && (
        <ClearableSelectWrapper className={css.wrapper}>
          <Popover2
            minimal
            usePortal
            captureDismiss
            ref={popoverRef}
            position={Position.BOTTOM}
            onOpening={onPopoverOpening}
            modifiers={{
              arrow: { enabled: false },
              flip: { enabled: false },
            }}
            content={
              <div className={css.popover_container}>
                <div className={css.wrapper_search_input}>
                  <SearchField
                    onClickClearSearch={handleClearSearch}
                    onChange={handleSearch}
                    value={searchQuery}
                  />
                </div>

                <div className={css.list}>
                  {isEmpty(treeLocationContents) && searchQuery ? (
                    <div className={css.no_found_text}> We couldn't find any matches</div>
                  ) : (
                    <Tree
                      contents={treeLocationContents}
                      onNodeClick={handleLocationNodeClick}
                      onNodeCollapse={handleLocationNodeCollapse}
                      onNodeExpand={handleLocationNodeExpand}
                    />
                  )}
                </div>
              </div>
            }
          >
            <Button className="my-3 text-" minimal blue iconName="plus" text="Add Locations" />
          </Popover2>
        </ClearableSelectWrapper>
      )}
    </>
  )
}
